@if (isUnEnabledForCurrentApp()) {
  <button
    #appSwitchTrigger="matMenuTrigger"
    id="app-switch-button"
    (click)="isMobile ? showInSidenav() : focusActiveApp()"
    [matMenuTriggerFor]="isMobile ? null : appMenu"
    [class.btn-hover]="!isDDorCollections()"
    aria-label="Switch application"
    [disabled]="isLoginPopupDisplayed"
    type="button"
    class="un-app-switch-button"
    >
    <fa-icon class="app-icon" icon="grid" title="Applications"></fa-icon>
    @if (!isMobile && getCurrentAppName()) {
      <span id="current-app-name">{{getCurrentAppName()}}</span>
    }
    @if (!isMobile) {
      <fa-icon [icon]="['fas', 'chevron-down']"></fa-icon>
    }
  </button>
} @else {
  <button
    #appSwitchTrigger="matMenuTrigger"
    id="app-switch-button"
    (click)="focusActiveApp()"
    [matMenuTriggerFor]="appMenu"
    aria-label="Switch application"
    (menuOpened)="closeSidenav()"
    [disabled]="isLoginPopupDisplayed"
    type="button"
    mat-icon-button
    >
    <mat-icon [svgIcon]="icons.WAFFLE" title="Applications"></mat-icon>
  </button>
}

<mat-menu [class]="isUnEnabledForCurrentApp() ? 'un-toolbar-mat-menu' : 'toolbar-mat-menu'" #appMenu="matMenu">
  <ng-template #appSwitcherTemplate>

    @if(isDestinyAdmin) {
      <div class="app-switcher un">
        <div [ngClass]="{'app-group': isUnEnabledForCurrentApp()}">
          <div class="apps-list">
            <button
              class="app-button"
              [ngClass]="{ active: checkActiveApp('District Home') }"
              id="destiny-admin-home"
              (click)="goToDistrictHomePage()"
              mat-menu-item
            >
              <span id="destiny-admin-home-text">District Home</span>
            </button>     

            <button
              class="app-button"
              [ngClass]="{ active: checkActiveApp('District Setup') }"
              id="destiny-admin-setup"
              (click)="gotoDestinySetup()"
              mat-menu-item
            >
              <span id="destiny-admin-setup-text">District Setup</span>
            </button>    

            @if (shouldShowDestinyAi()) {
              <button
                class="app-button"
                [ngClass]="{ active: checkActiveApp('Destiny AI') }"
                id="destiny-admin-home"
                (click)="goToDestinyAi()"
                mat-menu-item
                >
                <span id="destiny-admin-home">Destiny AI</span>
              </button>
            }

          </div>
        </div>
      </div>
    }


    @if (isUnEnabledForCurrentApp()) {
      <div class="app-switcher-header">
        <span class="app-switcher-header-text">
          Products
        </span>
      </div>
    }


    <div  class="app-switcher" [class.un]="isUnEnabledForCurrentApp()">
      @for (appGroup of AppGroup; track appGroup; let i = $index; let isFirst = $first) {
        @if (appsByGroup && appsByGroup[appGroup]) {
          <div [ngClass]="{'app-group': isUnEnabledForCurrentApp(), 'group-spacer': !isUnEnabledForCurrentApp()}">
            @if (!isUnEnabledForCurrentApp()) {
              <span class="group-header">{{ appGroup }}</span>
            }
            @if (!isUnEnabledForCurrentApp()) {
              <mat-divider class="divider"></mat-divider>
            }
            <div class="apps-list">
              @for (app of appsByGroup[appGroup]; track app; let j = $index) {
                @if (getAppName(app.app) !== 'District Setup') {  <!-- Destiny Admin should not see Setup. Link to district setup is above. -->
                  <button
                    class="app-button"
                    [ngClass]="{ active: checkActiveApp(app.app) }"
                    id="app-switch-{{i}}-{{j}}"
                    (click)="appChange(app)"
                    mat-menu-item
                    >
                    @if (!isUnEnabledForCurrentApp()) {
                      <mat-icon class="app-icon" [svgIcon]="app.icon"></mat-icon>
                    }
                    @if (app.isExternal) {
                      <span
                        id="appdestiny-{{i}}-{{j}}-name"
                        attr.aria-label="Launch {{ app.app }} in a new tab"
                        class="external-app-text"
                        >
                        {{ app.app }}
                        @if (!isUnEnabledForCurrentApp()) {
                          <mat-icon
                            [svgIcon]="icons.ARROW_RIGHT_CORNER"
                            id="is-external-app-icon-{{i}}-{{j}}"
                            class="external-app"
                            >
                          </mat-icon>
                        }
                        @if (isUnEnabledForCurrentApp()) {
                          <fa-icon id="is-external-app-icon-{{i}}-{{j}}" [icon]="['far', 'arrow-up-right-from-square']"></fa-icon>
                        }
                      </span>
                    }
                    @if (!app.isExternal) {
                      <span id="appdestiny-{{i}}-{{j}}-name">
                        {{getAppName(app.app)}}
                      </span>
                    }
                  </button>
                }
              }
            </div>
          </div>
        }
      }
    </div>
  </ng-template>
  <ng-container *ngTemplateOutlet="appSwitcherTemplate"></ng-container>
</mat-menu>

